import type { Template as WysiwygTemplate } from '../wysiwyg/types';
import type { TemplateFormatOption } from '../TemplateFormatBadge';

export function parseTemplateForClone(
  content: unknown,
  metadata?: Pick<WysiwygTemplate, 'outputFormat' | 'dpi'>,
): WysiwygTemplate | null {
  let parsed = content;
  if (typeof parsed !== 'object' && (typeof parsed !== 'string' || !parsed)) return null;

  try {
    if (typeof parsed === 'string') parsed = JSON.parse(parsed);
    if (typeof parsed === 'string') parsed = JSON.parse(parsed);
  } catch {
    return null;
  }

  if (!parsed || typeof parsed !== 'object') return null;
  const template = parsed as Partial<WysiwygTemplate> & {
    AllBrands?: unknown;
    BrandIds?: unknown;
  };
  if (!Number.isFinite(template.width) || !Number.isFinite(template.height) || !Array.isArray(template.elements)) {
    return null;
  }
  const allBrands = typeof template.allBrands === 'boolean'
    ? template.allBrands
    : typeof template.AllBrands === 'boolean'
      ? template.AllBrands
      : undefined;
  const brandIds = Array.isArray(template.brandIds)
    ? template.brandIds
    : Array.isArray(template.BrandIds)
      ? template.BrandIds
      : undefined;
  return {
    ...template,
    ...(allBrands === undefined ? {} : { allBrands }),
    ...(brandIds === undefined ? {} : { brandIds }),
    outputFormat: template.outputFormat ?? metadata?.outputFormat,
    dpi: template.dpi ?? metadata?.dpi,
  } as WysiwygTemplate;
}

export function getCrossFormatCloneName(sourceName: string, target: TemplateFormatOption): string {
  const suffix = target.format === 'pdf' ? 'PDF' : `ZPL ${target.dpi}`;
  return `${sourceName} - ${suffix}`;
}
